import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { Subscription } from 'rxjs';
import { API as AWS_API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { API, CONST_AWS_API, DEFAULT_IMAGE } from 'src/app/core/constants';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { AppService } from 'src/app/core/services/app.service';
import { MatTableDataSource } from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import { StorageService } from 'src/app/core/services/storage.service';
import { groupTeamsByNetwork, filterTeamGroups, GroupedTeams } from 'src/app/core/utils/team-grouping.util';
declare let $: any;
declare let ga: Function;

@Component({
  selector: 'app-gener-list',
  templateUrl: './gener-list.component.html',
  styleUrls: ['./gener-list.component.scss']
})
export class GenerListComponent implements OnInit {

  streamingData: any;
  displayName: any;
  performerInfo: any;
  userInfo: any = {};
  liveEventSubscr: Subscription;
  deviceData: Subscription;
  @ViewChild('widgetsContent', { static: false }) widgetsContent: ElementRef;
  icWebpageSettingsData: any = {};
  userInfoSubscription: Subscription;
  settingsData: any = {};
  settingsDataSubscription: Subscription;
  org_info: any = {};
  eventList: any = [];
  performerInfoSubscr: Subscription;
  subscriptiondetails: any;
  deviceType: string;
  centerAds: any[];
  showTimer: boolean;
  rightAds: any;
  org_id: any;
  preloadAdsdata: any[];
  eventHomeAdsTop: any[];
  adVideo: any;
  streamAdsData: any;
  sponsorData: any;
  closeButton: boolean;
  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  activePageDataChunk = [];
  routerevents: any;
  assets_url = environment.assets_url

  // Group/Home Team/Away Team/Division/Sport filters - ported from event-marketplace.component.ts
  // (same <app-filter-dropdown> reuse, same field names). Filters only the currently-loaded page
  // of eventList, not across pagination - see marketplace-date-range-filter spec's US-5.
  groupsList: any[] = [];
  groupsLabel = 'Group';
  allDivisions: any[] = [];
  allSports: any[] = [];
  teamsList: any[] = [];
  teamsNetworkLabel = '';
  homeGroupGroups: GroupedTeams = { networkLabel: '', networkTeams: [], groupedTeams: [] };
  awayGroupGroups: GroupedTeams = { networkLabel: '', networkTeams: [], groupedTeams: [] };

  selectedGroup: any = null;
  selectedGroupName = '';
  selectedHomeTeam: any = null;
  selectedHomeTeamName = '';
  selectedAwayTeam: any = null;
  selectedAwayTeamName = '';
  selectedDivision: any = null;
  selectedDivisionName = '';
  selectedSport: any = null;
  selectedSportName = '';
  groupSearchText = '';
  homeTeamSearchText = '';
  awayTeamSearchText = '';

  groupDisplayFn = (g: any) => g?.group_name || g?.name || '';
  teamDisplayFn = (t: any) => t?.name || '';
  divisionDisplayFn = (d: any) => d?.category_name || d?.name || '';
  sportDisplayFn = (s: any) => s?.sport_name || s?.name || '';

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.code == "ArrowRight") {
      this.scrollRight();
    }
    if (event.code == "ArrowLeft") {
      this.scrollLeft();
    }
  }

  constructor(public router: Router,
    private commanSubscribeService: CommanSubscribeService,
    private userService: UserService,
    public activatedRoute: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    public sanitizer: DomSanitizer,
    private appService: AppService,
    private storageService:StorageService,
    private titleService: Title) {
  }
  showScroll: boolean;
  showScrollHeight = 300;
  hideScrollHeight = 10;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if ((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) > this.showScrollHeight) {
      this.showScroll = true;
    }
    else if (this.showScroll && (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) < this.hideScrollHeight) {
      this.showScroll = false;
    }
  }
  ngOnInit() {
    // Home passes the genre's name when "view all" is clicked; the tag response can override it.
    this.genreName = (history.state && history.state.genreName) || '';
    this.imageScroll()
    this.userInfo = this.commanSubscribeService.userInfo;
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.deviceType = this.commanSubscribeService.deviceType;
    this.deviceData = this.commanSubscribeService.getAppType().subscribe(response => {
      this.deviceType = response;
    });

    let locInfo = this.commanSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');

    this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    this.settingsDataSubscription = this.commanSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response;
      this.checkIsSubscribed();
      if (this.activatedRoute.snapshot.params.tag_category != "recorded-video") {
        this.getData();
      }
    });

    if (Object.keys(this.settingsData).length > 0 && this.activatedRoute.snapshot.params.tag_category != "recorded-video") {
      this.getData();
    }

    let perfomerInfoData = this.commanSubscribeService.perfomerInfoData;
    this.performerInfoSubscr = this.commanSubscribeService.getPerfomerInfo().subscribe(response => {
      this.getPerformerInfo(response);
    });
    if (Object.keys(this.settingsData).length > 0) {
      document.body.classList.add("home");
    }

    if (Object.keys(perfomerInfoData).length > 0)
      this.getPerformerInfo(perfomerInfoData);

  }

  redirectTo() {
    if (!this.router.url.includes('/preview')) {
      this.router.navigateByUrl('/');
    }
  }

  getData() {
    if (!this.settingsData.is_preview) {
      if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
        this.commanSubscribeService.getCurrentLocation((val: any, json: any) => {
          if (val == "fail") {
            this.currentLocation = {};
          } else {
            this.currentLocation = json;
          }
        });
        this.getVodByTag();
      } else {
        this.getVodByTag();
      }
    } else if (this.activatedRoute.snapshot.queryParams.token && this.router.url.includes('preview')) {
      this.getSelectedTagInfo();
    }
  }

  getPerformerInfo(response) {

    // let data = {
    //   headers: {
    //     "Content-Type": "application/json",
    //     "x-api-key": environment.AWS_Cognito.X_Api_Key,
    //     "Authorization": `Bearer ${this.userInfo.access_token}`
    //   },
    //   response: true,
    //   body: {
    //     "channel_name": this.activatedRoute.snapshot.params.channelName
    //   }
    // }
    // this.ngxLoader.start();
    // API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_PERFORMER_INFO, data).then(response => {
    //   this.ngxLoader.stop(); 
    if (response.data.statusCode === '200') {
      this.titleService.setTitle(response.data.Data[0]?.channel_display_name);
      console.log("pagetitle",response,response.data.Data[0]?.channel_display_name);
      this.performerInfo = response.data.Data[0]?.performer_details;
      if (this.performerInfo) {
        this.performerInfo.performer_profile_banner = this.performerInfo.performer_profile_banner ? this.performerInfo.performer_profile_banner : DEFAULT_IMAGE.IMAGE_2;
        this.subscriptiondetails = response.data.Subscription_details
        if (this.subscriptiondetails && this.subscriptiondetails.length > 0) {
          this.checkIsSubscribed();
        }
        console.log(this.subscriptiondetails, response)
      }
      if (response.data.Data[0]?.org_info) {
        this.org_info = response.data.Data[0]?.org_info;
        if (this.org_info) {
          this.org_info.channel_banner = this.org_info.channel_banner ? this.org_info.channel_banner : DEFAULT_IMAGE.IMAGE_2;
        }
        if (this.org_info && this.org_info.vod_site_id) {
          this.getAds();
        }
      }

      this.groupsList = response.data.Data[0]?.groups || [];
      this.groupsLabel = response.data.Data[0]?.network_type_label || 'Group';
      this.allDivisions = response.data.Data[0]?.categories || [];
      this.allSports = response.data.Data[0]?.sports || [];
      this.teamsNetworkLabel = response.data.Data[0]?.channel_display_name || '';
      this.getTeamsList();
      this.applyActiveGroupDefault();

      if (this.activatedRoute.snapshot.params.tag_category == "recorded-video") {
        this.getRecordedVideosList();
      }
      try { ga('set', 'page', this.router.url); ga('send', 'pageview'); } catch (e) { }
      // this.getVodByTag();
      // this.getSelectedTagInfo();
    }
    // }).catch(error => {
    //   this.ngxLoader.stop();
    // });

  }

  // Group is already implied by the URL when browsing a group-scoped page, so the Group
  // filter card is redundant and hidden - same pattern as event-marketplace's isGroupScoped.
  get isGroupScoped(): boolean {
    return !!this.commanSubscribeService.activeGroupId;
  }

  // When browsing at a group-scoped URL, default the group filter to the active group so
  // Division/Sport narrow immediately, without the fan re-picking a group they can't even see
  // the filter for (it's hidden by isGroupScoped above) - mirrors
  // event-marketplace.component.ts's applyActiveGroupDefault(). Sets state directly (not via
  // selectGroup()) so it doesn't re-filter activePageDataChunk before a fetch has populated
  // eventList.
  private applyActiveGroupDefault() {
    if (this.selectedGroup || !this.commanSubscribeService.activeGroupId) return;
    const activeGroup = (this.groupsList || []).find((g: any) => Number(g.id) === Number(this.commanSubscribeService.activeGroupId));
    if (!activeGroup) return;
    this.selectedGroup = activeGroup.id;
    this.selectedGroupName = activeGroup.group_name || activeGroup.name;
  }

  // Home/Away Team options are sourced from the teams API (league/team/all), same as
  // event-marketplace.component.ts's getTeamsList().
  getTeamsList() {
    const organizationId = this.org_info?.id ?? this.settingsData?.organization_id;
    if (!organizationId) return;
    this.appService.postBaseRequest(API.GET_TEAMS, { organizationId }).subscribe((result: any) => {
      this.teamsList = ((result && result.data) || []).filter((team: any) => team.dataStatus === 'A');
      this.refreshHomeGroupGroups(this.selectedAwayTeam);
      this.refreshAwayGroupGroups(this.selectedHomeTeam);
    }, (error) => {
      console.error('Error loading teams:', error);
      this.teamsList = [];
    });
  }

  refreshHomeGroupGroups(excludeTeamId?: any) {
    const teams = (this.teamsList || []).filter((t: any) => !this.isExcludedTeam(t, excludeTeamId));
    const grouped = groupTeamsByNetwork(teams, this.groupsList, this.teamsNetworkLabel);
    this.homeGroupGroups = filterTeamGroups(grouped, this.homeTeamSearchText);
  }

  refreshAwayGroupGroups(excludeTeamId?: any) {
    const teams = (this.teamsList || []).filter((t: any) => !this.isExcludedTeam(t, excludeTeamId));
    const grouped = groupTeamsByNetwork(teams, this.groupsList, this.teamsNetworkLabel);
    this.awayGroupGroups = filterTeamGroups(grouped, this.awayTeamSearchText);
  }

  // A group's categories_sports (e.g. [{category_id: 79, sport_ids: [35,44]}]) scopes which
  // divisions/sports belong to it - same restriction pattern as event-marketplace.component.ts.
  private getAllowedDivisionSportsForGroup(groupId: any): { divisionIds: Set<number>; sportIdsByDivision: Map<number, Set<number>> } | null {
    if (!groupId) return null;
    const group = (this.groupsList || []).find((g: any) => Number(g.id) === Number(groupId));
    const divisionIds = new Set<number>();
    const sportIdsByDivision = new Map<number, Set<number>>();
    (group?.categories_sports || []).forEach((entry: any) => {
      const divisionId = Number(entry.category_id);
      divisionIds.add(divisionId);
      const sportIds = sportIdsByDivision.get(divisionId) || new Set<number>();
      (entry.sport_ids || []).forEach((sportId: any) => sportIds.add(Number(sportId)));
      sportIdsByDivision.set(divisionId, sportIds);
    });
    return { divisionIds, sportIdsByDivision };
  }

  private isExcludedTeam(candidate: any, excludedId: any): boolean {
    if (excludedId === null || excludedId === undefined || excludedId === '') return false;
    if (this.isSameTeamId(candidate.id, excludedId)) return true;
    const excluded = (this.teamsList || []).find((t: any) => this.isSameTeamId(t.id, excludedId));
    return !!excluded && !!candidate.name && !!excluded.name
      && candidate.name.trim().toLowerCase() === excluded.name.trim().toLowerCase();
  }

  private isSameTeamId(a: any, b: any): boolean {
    if (a === null || a === undefined || b === null || b === undefined) return false;
    return String(a) === String(b);
  }

  private getTeamNetworkGroupName(team: any): string {
    if (!team || !team.networkGroupId) return '';
    const group = (this.groupsList || []).find((g: any) => g.id == team.networkGroupId);
    return group ? (group.network_group_name || group.group_name || group.name) : '';
  }

  get divisionOptions(): any[] {
    const allowed = this.getAllowedDivisionSportsForGroup(this.selectedGroup);
    if (!allowed) return this.allDivisions;
    return (this.allDivisions || []).filter((d: any) => allowed.divisionIds.has(Number(d.category_id ?? d.id)));
  }

  get sportOptions(): any[] {
    const allowed = this.getAllowedDivisionSportsForGroup(this.selectedGroup);
    if (!allowed) return this.allSports;
    if (this.selectedDivision) {
      const sportIds = allowed.sportIdsByDivision.get(Number(this.selectedDivision));
      return (this.allSports || []).filter((s: any) => sportIds ? sportIds.has(Number(s.sport_id ?? s.id)) : false);
    }
    const allowedSportIds = new Set<number>();
    allowed.sportIdsByDivision.forEach((ids) => ids.forEach((id) => allowedSportIds.add(id)));
    return (this.allSports || []).filter((s: any) => allowedSportIds.has(Number(s.sport_id ?? s.id)));
  }

  onHomeTeamSearchTextChange(value: string) {
    this.homeTeamSearchText = value;
    this.refreshHomeGroupGroups(this.selectedAwayTeam);
  }

  onAwayTeamSearchTextChange(value: string) {
    this.awayTeamSearchText = value;
    this.refreshAwayGroupGroups(this.selectedHomeTeam);
  }

  selectGroup(group: any) {
    this.selectedGroup = group ? group.id : null;
    this.selectedGroupName = group ? (group.group_name || group.name) : '';
    this.selectedDivision = null;
    this.selectedDivisionName = '';
    this.selectedSport = null;
    this.selectedSportName = '';
    this.groupSearchText = '';
    this.activePageDataChunk = this.applyPageFilters(this.eventList);
  }

  selectHomeTeam(team: any) {
    this.selectedHomeTeam = team ? team.id : null;
    const networkGroupName = this.getTeamNetworkGroupName(team);
    this.selectedHomeTeamName = team ? (networkGroupName ? `${team.name} (${networkGroupName})` : team.name) : '';
    this.homeTeamSearchText = '';
    this.refreshAwayGroupGroups(this.selectedHomeTeam);
    this.activePageDataChunk = this.applyPageFilters(this.eventList);
  }

  selectAwayTeam(team: any) {
    this.selectedAwayTeam = team ? team.id : null;
    const networkGroupName = this.getTeamNetworkGroupName(team);
    this.selectedAwayTeamName = team ? (networkGroupName ? `${team.name} (${networkGroupName})` : team.name) : '';
    this.awayTeamSearchText = '';
    this.refreshHomeGroupGroups(this.selectedAwayTeam);
    this.activePageDataChunk = this.applyPageFilters(this.eventList);
  }

  selectDivision(division: any) {
    this.selectedDivision = division ? (division.category_id ?? division.id) : null;
    this.selectedDivisionName = division ? (division.category_name ?? division.name) : '';
    if (this.selectedSport !== null && !this.sportOptions.some((s: any) => Number(s.sport_id ?? s.id) === Number(this.selectedSport))) {
      this.selectedSport = null;
      this.selectedSportName = '';
    }
    this.activePageDataChunk = this.applyPageFilters(this.eventList);
  }

  selectSport(sport: any) {
    this.selectedSport = sport ? (sport.sport_id ?? sport.id) : null;
    this.selectedSportName = sport ? (sport.sport_name ?? sport.name) : '';
    this.activePageDataChunk = this.applyPageFilters(this.eventList);
  }

  // GET_VOD_BY_TAG's Data items carry these fields nested under stream_info (confirmed against a
  // real response 2026-08-27), not flat on the item like event-marketplace's dumarray - other
  // fetch paths (getRecordedVideosList/getSelectedTagInfo) aren't confirmed the same way, so this
  // falls back to the flat field if stream_info isn't present rather than assuming one shape.
  private filterField(item: any, field: string): any {
    return item?.stream_info ? item.stream_info[field] : item?.[field];
  }

  // Filters only the currently-loaded page(s) in eventList, not across pagination - see
  // marketplace-date-range-filter spec's US-5 pagination decision.
  applyPageFilters(sourceList: any[]): any[] {
    let list = sourceList || [];
    if (this.selectedGroup) {
      list = list.filter((arr: any) => Number(this.filterField(arr, 'network_group_id')) === Number(this.selectedGroup));
    }
    if (this.selectedHomeTeam) {
      list = list.filter((arr: any) => this.isSameTeamId(this.filterField(arr, 'home_team_id'), this.selectedHomeTeam));
    }
    if (this.selectedAwayTeam) {
      list = list.filter((arr: any) => this.isSameTeamId(this.filterField(arr, 'away_team_id'), this.selectedAwayTeam));
    }
    if (this.selectedDivision) {
      list = list.filter((arr: any) => Number(this.filterField(arr, 'network_group_category_id')) === Number(this.selectedDivision));
    }
    if (this.selectedSport) {
      list = list.filter((arr: any) => Number(this.filterField(arr, 'network_sport_id')) === Number(this.selectedSport));
    }
    return list;
  }

  isSubscribed = false;
  checkIsSubscribed() {
    this.isSubscribed = false;
    let cid;
    if (this.settingsData && this.settingsData.channelInfo && this.settingsData.channelInfo.channel_id)
      cid = this.settingsData.channelInfo.channel_id;

    if (this.router.url.includes('/channel/')) {
      if (this.settingsData && this.settingsData.channelInfo && this.settingsData.channelInfo.subscription == 0) {
        cid = 0;
      }
    }
    if (this.subscriptiondetails) {
      this.subscriptiondetails.forEach(element => {
        if ((element.channel_id == cid || (!element.channel_id && !this.router.url.includes('/channel/'))) && element.payment == 'success') {
          this.isSubscribed = true;
        }
      });
    }
  }

  length: any;
  getSelectedTagInfo() {
    let data = { "token": this.activatedRoute.snapshot.queryParams.token, "id": this.activatedRoute.snapshot.params.tag_id };
    this.ngxLoader.start();
    this.appService.postRequest(API.CHANNEL_TAG, data).subscribe(response => {
      this.ngxLoader.stop();
      if (response.statusCode === 200) {
        this.eventList = response.Data || [];
        this.dataSource.data = this.eventList;
        this.length = this.eventList.length;
        this.eventList.forEach(e => {
          if (!e.video_thumbnail_image) {
            e.video_thumbnail_image = this.assets_url + "audio_default_image.png";
          }
          e.is_can_see_album = true;
        });
        this.activePageDataChunk = this.applyPageFilters(this.eventList.slice(0, this.pageSize));
      }
    }, error => {
      this.ngxLoader.stop();
    });
  }

  imageScroll() {
    (function HorizontalScrolling() {
      function wheelHandler(element, event) {
        const toLeft = event.deltaY < 0 && element.scrollLeft > 0
        const toRight = event.deltaY > 0 && element.scrollLeft < element.scrollWidth - element.clientWidth

        if (toLeft || toRight) {
          event.preventDefault()
          event.stopPropagation()

          element.scrollBy({ left: event.deltaY * 12 })
        }
      }

      const targets = document.querySelectorAll('#event-container')

      targets.forEach(element => element.addEventListener('wheel', event => wheelHandler(element, event)))
    })()
  }
  scrollLeft() {
    this.widgetsContent.nativeElement.scrollLeft -= 1250;
  }

  scrollRight() {
    this.widgetsContent.nativeElement.scrollLeft += 1250;
  }
  goTO() {
        const ch = this.activatedRoute.snapshot.params.channelName;
    const base = this.commanSubscribeService.getChannelBasePath(ch);
    if (!this.settingsData.is_preview) {
      this.router.navigate([base + '/subscription-list']);
    } else {
      this.router.navigate([base + '/subscription-list'], { queryParams: { token: this.activatedRoute.snapshot.queryParams.token } });
    }
  }

  goICHome() {
    const ch = this.activatedRoute.snapshot.params.channelName;
    const base = this.commanSubscribeService.getChannelBasePath(ch);
    if (!this.settingsData.is_preview) {
      if (this.settingsData && this.settingsData.channelInfo && this.settingsData.channelInfo.channel_id && this.settingsData.channelInfo.channel_id != 0)
        this.router.navigate([base + '/channel/' + this.settingsData.channelInfo.channel_name])
      else
        this.router.navigate([base]);
    } else {
      this.router.navigate([base + "/preview/"], { queryParams: { token: this.activatedRoute.snapshot.queryParams.token } });
    }
  }

  genreName = '';

  // Sub-channel pages use their own banner; otherwise the channel banner (which already falls back to a default image).
  get bannerUrl(): string {
    return this.router.url.includes('/channel/') ? this.settingsData?.banner_image : this.org_info?.channel_banner;
  }

  // "48 videos" / "1 track" under the genre name; empty until something has loaded.
  get itemCountLabel(): string {
    const count = this.totalCount || this.length || 0;
    if (!count) return '';
    const noun = this.activatedRoute?.snapshot?.params?.tag_category === 'audio' ? 'track' : 'video';
    return count + ' ' + noun + (count === 1 ? '' : 's');
  }

  // Same rule as the Home genre card: the substituted audio_default_image.png isn't a real thumbnail.
  hasOwnThumbnail(item: any): boolean {
    const src: string = item?.video_thumbnail_image || '';
    return !!src && !src.endsWith('audio_default_image.png');
  }

  // Drives the card's type icon and fallback; same source goToAlbum uses for the album URL.
  getMediaType(item: any): 'audio' | 'video' {
    const type = item?.stream_info?.vod_video_audio || item?.tag_category
      || this.activatedRoute?.snapshot?.params?.tag_category;
    return type === 'audio' ? 'audio' : 'video';
  }

  goToAlbum(data) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Album clicked: ${data.title || data.slug} - ${userId}`);
    const u_payload = {
      actionType: "community",
      metaData: {
        title: `Album clicked: ${data.title || data.slug}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.org_info?.id || null,
      networkGroupId : data?.network_group_id || null,
      clickAction: 'album-clicked'
    };
    this.commanSubscribeService.sendTriggeredEvent(u_payload);

    const ch = this.activatedRoute.snapshot.params.channelName;
    const base = this.commanSubscribeService.getChannelBasePath(ch);
    let tagCat = data.stream_info && data.stream_info.vod_video_audio ? data.stream_info.vod_video_audio : data.tag_category;
    let slug = data.stream_info && data.stream_info.slug ? data.stream_info.slug : data.slug;
    if (this.settingsData.is_preview) {
      this.commanSubscribeService.albumBackHistory = base + "/album/" + tagCat + "/" + slug + "/preview";
      this.router.navigate([base + "/album/" + tagCat + "/" + slug + "/preview"], { queryParams: { token: this.activatedRoute.snapshot.queryParams.token } });
    } else {
      this.commanSubscribeService.albumBackHistory = base + "/album/" + tagCat + "/" + slug;
      this.router.navigate([base + "/album/" + tagCat + "/" + slug]);
    }
  }

  currentLocation: any = {};
  totalCount = 0;
  pageSize = 20;
  pageSizeOptions: number[] = [20, 40, 60, 80, 100];
  limit = 20;
  paginatorToken: any;
  showPagination: boolean = false;
  previousPageToken: any;
  paginatorArr = [];
  getVodByTag(event?) {

    if (event) {
      this.limit = event.pageSize;
      if (event.pageSize != this.pageSize) {
        this.paginatorToken = '';
        this.pageSize = event ? event.pageSize : this.limit;
        this.showPagination = false;
      }
    } else {
      this.limit = 20;
    }
    // this.commanSubscribeService.getCurrentLocation((val: any, json: any) => {

      // if (val == "fail") {
      //   this.currentLocation = {};
      // } else {
      //   this.currentLocation = json;
      // }
      let orgToken;
      if (event && event.pageIndex > event.previousPageIndex) {
        orgToken = this.paginatorToken;
      } else {
        orgToken = this.previousPageToken ? this.previousPageToken : ''
      }
      if (event && event.previousPageIndex > event.pageIndex) {
        orgToken = this.paginatorArr[event.pageIndex - 1];
      }
      if (event && event.pageIndex == 0) {
        orgToken = '';
      }
      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          "Authorization": `Bearer ${this.userInfo.access_token}`
        },
        response: true,
        body: {
          performer_id: this.activatedRoute.snapshot.params.performer_id,
          tag_id: this.activatedRoute.snapshot.params.tag_id,
          category: this.activatedRoute.snapshot.params.tag_category,
          channel_id: this.settingsData && this.settingsData.channelInfo && this.settingsData.channelInfo.channel_id ? this.settingsData.channelInfo.channel_id : 0,
          network_group_id: this.commanSubscribeService.activeGroupId || 0,
          limit: this.limit,
          paginationToken: orgToken ? orgToken : ''
        }
      }
      this.ngxLoader.start();
      AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_VOD_BY_TAG, data).then(response => {
        this.ngxLoader.stop();
        if (response.data.statusCode === '200') {

          this.paginatorToken = response.data.paginationToken;
          if (response.data.paginationToken) {
            this.paginatorArr.push(response.data.paginationToken);
          }
          this.totalCount = response.data.tag.count;
          this.genreName = response.data.tag.tag_name || response.data.tag.name || this.genreName;
          this.eventList = response.data.Data || [];
          this.eventList.forEach(e => {
            if (!e.stream_info.video_thumbnail_image) {
              e.stream_info.video_thumbnail_image = this.assets_url + "audio_default_image.png";
            }
            e.video_thumbnail_image = e.stream_info.video_thumbnail_image;
            e.title = e.stream_info.stream_video_title;
            e.slug = e.stream_info.slug;

            e.is_can_see_album = false;
            if (e.metadata && e.metadata.additional_info) {
              let additional_info = JSON.parse(e.metadata.additional_info);
              if (!additional_info.geo_block || additional_info.geo_block.includes("all") || additional_info.geo_block.includes(this.currentLocation.country_code2)) {
                e.is_can_see_album = true;
              }
            } else {
              e.is_can_see_album = true;
            }

          });
          this.activePageDataChunk = this.applyPageFilters(this.eventList);
          this.showPagination = true;
        }
      }).catch(error => {
        this.ngxLoader.stop();
      });
    // });

  }
  async getAds() {
    let allDiv = [];
    let count = 0;
    var temp_site_id = null;
    this.centerAds = [];
    console.log('Stream page ads', this.streamAdsData);
    this.sponsorData = this.streamAdsData;
    var j = 0;
    var i = 1;
    var adTypeIdarr = [];
    var placements = [];
    j += 1;
    placements.push(
      {
        "divName": "div1",
        "networkId": Number(environment.kevel.NETWORK_ID),
        "siteId": this.org_info.vod_site_id,
        "advertiserId": this.org_info.advertiser_id,
        "adTypes": [43],
      }
    );
    allDiv.push("div1");
    count = count + 1;
    // if (this.streamAdsData.length == count) {
    let data = {
      "placements": placements,
      "allDiv": allDiv
    };
    if (this.org_info.vod_site_id && this.org_info.advertiser_id) {
      //"?NOLOADER"
      this.commanSubscribeService.getAdsData(data, (err, result) => {
        if (result && result.status == 0 && result.Ads_data.length > 0) {
          console.log(result.Ads_data, 'test');
          result.Ads_data.forEach(element => {
            if (element.contents && element.contents[0] && element.contents[0].data.customData && element.contents[0].data.customData.ad_size == "300x600") {
              this.centerAds.push(element);
            }
          });
          if (this.centerAds.length > 0) {
            this.centerAdsCount = this.centerAds.length;
            this.centerRollAds(this.centerAds);
          }
        }
      });
    }
  }
  adVideoCenter: any;
  showAdCenter: boolean;
  centerAdsCount: number = 1;
  selectedAdCenterData: any;
  adsCenterCount = 0;
  async centerRollAds(centerAdsdata) {
    this.adsCenterCount = this.adsCenterCount + 1;
    this.centerAdsCount = (this.centerAdsCount - 1);
    this.selectedAdCenterData = centerAdsdata[this.centerAdsCount].clickUrl;
    let index = this.centerAdsCount;
    if (centerAdsdata[index].contents && centerAdsdata[index].contents[0] && centerAdsdata[index].contents[0].body) {
      let adType = centerAdsdata[index].contents[0];
      let customData = adType.data['customData'] ? adType.data['customData'] : {};
      this.adVideoCenter = this.sanitizer.bypassSecurityTrustHtml(adType.body);
      this.showAdCenter = true;
      if (customData && customData.minPlayTime && customData.maxPlayTime && (Number(customData.maxPlayTime) <= Number(customData.minPlayTime))) {
        customData.maxPlayTime = Number(customData.minPlayTime) + 1;
      }
      var minplayTime = customData.minPlayTime ? customData.minPlayTime : 10;
      var maxPlayTime = customData.maxPlayTime ? (customData.maxPlayTime * 1000) : 20000;

      this.setTimerAd(minplayTime, () => { });
      if (centerAdsdata[index].impressionUrl) {
        this.commanSubscribeService.countAdsImpressions(centerAdsdata[index].impressionUrl);
      }
      // setTimeout(() => {
      //   this.centerCloseAdd();
      // }, maxPlayTime);
    }
    this.loadscript();
  }

  loadscript() {
    $(document).ready(function () {
      $('.ad img').attr('alt', ' ');
      $('.ad img').attr('title', ' ');
    });
  }
  showSkip: boolean = false;
  secondsData: any;

  setTimer(playTime, callback) {
    callback();
    let j = 0;
    this.showSkip = false;
    var interval = setInterval(() => {
      if (j >= playTime) {
        this.secondsData = "Skip Ads";
        this.showSkip = true;
      } else {
        this.secondsData = "Skip Ads in " + (playTime - j);
      }
      this.showTimer = true;
      if (j >= playTime) {
        clearInterval(interval);
      }
      j += 1;
    }, 1000);
  }
  setTimerAd(playTime, callback) {
    callback();
    let j = 0;
    this.showSkip = false;
    var interval = setInterval(() => {
      if (j >= playTime) {
        this.secondsData = " ";
        this.showSkip = true;
      } else {
        this.secondsData = " " + (playTime - j);
      }
      this.showTimer = true;
      if (j >= playTime) {
        clearInterval(interval);
      }
      j += 1;
    }, 1000);
  }

  getRecordedVideosList() {
    let videoParams = {
      "organization_id": this.org_info.id,
      // "limit":this.limit,
    }
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: videoParams
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_PAST_EVENTS, data).then(response => {
      this.ngxLoader.stop();
      let list = [];
      if (response.data.statusCode === '200') {
        this.eventList = response.data.Data || [];
        this.dataSource.data = this.eventList;
        this.length = this.eventList.length;

        this.eventList.forEach(e => {
          e.video_thumbnail_image = e.stream_info ? e.stream_info.video_thumbnail_image : this.assets_url + "audio_default_image.png",
            e.title = e.stream_info ? e.stream_info.stream_video_title : "";
          e.tag_category = "recorded-video";
          e.is_can_see_album = true;
        });
        this.activePageDataChunk = this.applyPageFilters(this.eventList.slice(0, this.pageSize));
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }

  onPageChanged(e) {
    let firstCut = e.pageIndex * e.pageSize;
    let secondCut = firstCut + e.pageSize;
    this.activePageDataChunk = this.applyPageFilters(this.eventList.slice(firstCut, secondCut));
  }


  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
    if (this.performerInfoSubscr)
      this.performerInfoSubscr.unsubscribe();
    if (this.settingsDataSubscription)
      this.settingsDataSubscription.unsubscribe();
  }

}
